import { useTranslations } from 'next-intl';
import { type ReactNode } from 'react';

import { Button } from '@/components/Button/Button';
import { Error } from '@/components/Error/Error';

export interface GenericErrorProps {
	onClickModel?: () => void;
	onClickSupport?: () => void;
	primaryCtaOverride?: ReactNode;
}

export function GenericError({ onClickModel, onClickSupport, primaryCtaOverride }: GenericErrorProps) {
	const t = useTranslations('page-generic-error');

	return (
		<Error title={t('title')} errorCode={''} description={t('description')}>
			<div className="d-flex d-flex-column sm:d-flex-row gap-6">
				{primaryCtaOverride ? (
					primaryCtaOverride
				) : (
					<Button className="w-full" as="a" href={t('model_cta_link')} onClick={onClickModel}>
						{t('model_cta')}
					</Button>
				)}{' '}
				<Button
					as="a"
					className="w-full justify-center"
					icon="arrow-right"
					iconPosition="right"
					onClick={onClickSupport}
					variant="tertiary"
				>
					{t('support_cta')}
				</Button>
			</div>
		</Error>
	);
}
